import { SchemaOf, object, string } from 'yup';

import { DateForm } from '../interface';

export interface DateIntervalForm {
  fromDate: string;
  toDate: string;
}

export const dateFormValidator: SchemaOf<DateForm> = object().shape({
  day: string().required(),
  month: string().required(),
  year: string().required(),
});

export const intervalValidator: SchemaOf<DateIntervalForm> = object().shape({
  fromDate: string()
    .required()
    .test('toBeforeFrom', function (fromDate) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const { toDate } = this.parent;
      if (toDate && fromDate) {
        return new Date(fromDate).toISOString() <= new Date(toDate as string).toISOString();
      }
      return false;
    }),
  toDate: string().required(),
});
